/* eslint-disable no-magic-numbers, no-bitwise, sonarjs/pseudo-random -- magic UUID script stolen from SO, you just don't question it */
export const randomUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replaceAll(/[xy]/g, (c) => {
    const r = Math.trunc(Math.random() * 16);

    const v = c === 'x' ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });
};
